export default {
  state: {
    classList: [],
    currentClass: null,
    currentLecture: null,
    teacherId: null,
    classRollModalOpen: false,
    classTournamentState: {
      tournamentId: null,
      selectedRoundNumber: null,
    },
    leaderboardModalOpen: false,
  },

  getters: {
    getCurrentClass: (state) => state.currentClass,
    getCurrentLecture: (state) => state.currentLecture,
    getClassList: (state) => state.classList,
    getTeacherId: (state) => state.teacherId,
    getClassRollModalOpen: (state) => state.classRollModalOpen,
    getClassTournamentState: (state) => state.classTournamentState,
    getLeaderboardModalOpen: (state) => state.leaderboardModalOpen,
  },

  mutations: {
    setCurrentClass(state, currentClass) {
      state.currentClass = {
        ...currentClass,
      };
    },
    setCurrentLecture(state, currentLecture) {
      state.currentLecture = {
        ...currentLecture,
      };
    },
    setClassList(state, classList) {
      state.classList = [...classList];
    },
    setTeacherId(state, teacherId) {
      state.teacherId = teacherId;
    },
    setClassRollModalOpen(state, isOpen) {
      state.classRollModalOpen = isOpen;
    },
    setClassTournamentState(state, classTournamentState) {
      state.classTournamentState = {
        ...state.classTournamentState,
        ...classTournamentState,
      };
    },
    setLeaderboardModalOpen(state, isOpen) {
      state.leaderboardModalOpen = isOpen;
    },
  },

  actions: {
    updateCurrentClass({ commit }, currentClass) {
      commit("setCurrentClass", currentClass);
    },
    updateCurrentLecture({ commit }, currentClass) {
      commit("setCurrentLecture", currentClass);
    },
    updateClassList({ commit }, classList) {
      commit("setClassList", classList);
    },
    updateTeacherId({ commit }, teacherId) {
      commit("setTeacherId", teacherId);
    },
    updateClassRollModalOpen({ commit }, isOpen) {
      commit("setClassRollModalOpen", isOpen);
    },
    updateClassTournamentState({ commit }, classTournamentState) {
      commit("setClassTournamentState", classTournamentState);
    },
    updateLeaderboardModalOpen({ commit }, isOpen) {
      commit("setLeaderboardModalOpen", isOpen);
    },
  },
};
